import { createAction } from 'deox';
import { ResponseErrors } from 'types';

export const buySubscription = {
  request: createAction('subscription/BUY_SUBSCRIPTIONS', resolve => (paymentMethod: string) =>
    resolve(paymentMethod),
  ),
  success: createAction('subscription/BUY_SUBSCRIPTIONS_SUCCESS'),
  fail: createAction('subscription/BUY_SUBSCRIPTIONS_FAIL', resolve => (error: ResponseErrors) =>
    resolve(error),
  ),
};

export const updateSubscription = {
  request: createAction('subscription/UPDATE_SUBSCRIPTIONS', resolve => (paymentMethod?: string) =>
    resolve(paymentMethod),
  ),
  success: createAction('subscription/UPDATE_SUBSCRIPTIONS_SUCCESS'),
  fail: createAction('subscription/UPDATE_SUBSCRIPTIONS_FAIL', resolve => (error: ResponseErrors) =>
    resolve(error),
  ),
};

export const deleteSubscription = {
  request: createAction('subscription/DELETE_SUBSCRIPTIONS'),
  success: createAction('subscription/DELETE_SUBSCRIPTIONS_SUCCESS'),
  fail: createAction('subscription/DELETE_SUBSCRIPTIONS_FAIL', resolve => (error: ResponseErrors) =>
    resolve(error),
  ),
};

export const showCancelPopup = createAction(
  'subscription/SHOW_CANCEL_POPUP',
  res => (payload: boolean) => res(payload),
);

export const clearError = createAction('subscription/CLEAR_ERROR');

// export const startSubscription = {
//   request: createAction('subscription/START_SUBSCRIPTIONS'),
//   success: createAction('subscription/START_SUBSCRIPTIONS_SUCCESS'),
//   fail: createAction('subscription/START_SUBSCRIPTIONS_FAIL', resolve => (error: ResponseErrors) =>
//     resolve(error),
//   ),
// };
